import React, {Component} from 'react';
import {Factory} from './components/desktop/factory';
import UsedTeamsContainer from './components/desktop/container';
import {connect} from 'react-redux';

class UsedTeams extends Component {
    render() {
        const {sportConfig} = this.props;
        const ViewComponent = Factory.getComponent(sportConfig);

        if (ViewComponent) {
            return (
                <UsedTeamsContainer>
                    <ViewComponent />
                </UsedTeamsContainer>
            );
        }

        return null;
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;
    return {
        sportConfig,
    };
}

const UsedTeamsComponent = connect(mapStatesToProps)(UsedTeams);

export {UsedTeamsComponent};
